import {
    DatasetIngestionV2Steps,
    DatasetIngestionWizardStep,
} from "../../components/dataset-ingestion-flow/dataset-ingestion-flow.interfaces";

/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
const PLACEHOLDER_ROUTE_SRN = ":srn";
const PLACEHOLDER_ROUTE_TYPE = ":type";
const PLACEHOLDER_ROUTE_STEP = ":step";

// V1
export const AppRoute = {
    BASE: "/",
    CONNECTION_DETAILS: `/connections/view/srn/${PLACEHOLDER_ROUTE_SRN}`,
    CONNECTIONS: "/connections",
    DATASETS: "/datasets",
    DATASETS_ALL: "/datasets/all",
    DATASETS_VIEW: `/datasets/view/srn/${PLACEHOLDER_ROUTE_SRN}`,
    DATASETS_EDIT: `/datasets/edit/srn/${PLACEHOLDER_ROUTE_SRN}`,
    DATASETS_CREATE: "/datasets/create",
    HOME: "/home",
    SIGN_IN: "/sign-in",
    SIGN_OUT: "/sign-out",
} as const;

export const getConnectionDetailsPath = (srn: string): string => {
    let path: string = AppRoute.CONNECTION_DETAILS;
    path = path.replace(PLACEHOLDER_ROUTE_SRN, srn);

    return path;
};

export const getDatasetsViewPath = (srn: string): string => {
    let path: string = AppRoute.DATASETS_VIEW;
    path = path.replace(PLACEHOLDER_ROUTE_SRN, srn);

    return path;
};

export const getDatasetsEditPath = (srn: string): string => {
    let path: string = AppRoute.DATASETS_EDIT;
    path = path.replace(PLACEHOLDER_ROUTE_SRN, srn);

    return path;
};

// V2
export const AppRouteV2 = {
    BASE: "/",
    CONNECTION: "/connection", // base for router
    CONNECTION_DETAILS: `/connection/view/srn/${PLACEHOLDER_ROUTE_SRN}`,
    CONNECTIONS_CREATE: "/connections/create",
    CONNECTIONS_CREATE_TYPE: `/connections/create/${PLACEHOLDER_ROUTE_TYPE}`,
    CUSTOM_DATASET: `/datasets/custom`,
    CUSTOM_DATASET_STEP: `/datasets/custom/${PLACEHOLDER_ROUTE_STEP}`,
    CONNECTIONS: "/connections",
    DATASET: "/dataset", // base for router
    DATASETS: "/datasets",
    DATASETS_ALL: "/datasets/all",
    DATASET_DETAILS: `/datasets/view/srn/${PLACEHOLDER_ROUTE_SRN}`,
    DATASET_EDIT: `/datasets/edit/srn/${PLACEHOLDER_ROUTE_SRN}`,
    DATASET_INGESTION: "/dataset/ingestion",
    DATASETS_CREATE: "/datasets/create",
    OVERVIEW: "/overview",
    SIGN_IN: "/sign-in-v2",
    SIGN_OUT: "/sign-out-v2",
} as const;

export const getCustomDatasetV2Path = (
    wizardStep: DatasetIngestionV2Steps
): string => {
    const path = AppRouteV2.CUSTOM_DATASET_STEP.replace(
        PLACEHOLDER_ROUTE_STEP,
        wizardStep
    );

    return path;
};

export const getDatasetsIngestionWizardStepPath = (
    wizardStep: DatasetIngestionWizardStep
): string => {
    const path = `${AppRouteV2.DATASET_INGESTION}/${wizardStep}`;

    return path;
};

export const getConnectionDetailsPathV2 = (srn: string): string => {
    let path: string = AppRouteV2.CONNECTION_DETAILS;
    path = path.replace(PLACEHOLDER_ROUTE_SRN, srn);

    return path;
};

export const getConnectionCreateTypePathV2 = (
    connectionType: string
): string => {
    let path: string = AppRouteV2.CONNECTIONS_CREATE_TYPE;
    path = path.replace(PLACEHOLDER_ROUTE_TYPE, connectionType);

    return path;
};

export const getDatasetViewPath = (srn: string): string => {
    let path: string = AppRouteV2.DATASET_DETAILS;
    path = path.replace(PLACEHOLDER_ROUTE_SRN, srn);

    return path;
};

export const getDatasetEditPath = (srn: string): string => {
    let path: string = AppRouteV2.DATASET_EDIT;
    path = path.replace(PLACEHOLDER_ROUTE_SRN, srn);

    return path;
};
